import type { SizeMm } from '@repo/api-contracts';

export interface ComponentGrid {
  spacingMm: number;
  vertical: number[];
  horizontal: number[];
}
const MAX_GRID_LINES = 200;

/** The chosen spacing grows explicitly; the Component's physical size never changes. */
export const componentGrid = (component: SizeMm, requestedSpacingMm: number): ComponentGrid => {
  if (!Number.isFinite(requestedSpacingMm) || requestedSpacingMm <= 0)
    throw new RangeError('Grid 간격은 양수 mm여야 합니다.');
  const factor = Math.max(
    1,
    Math.ceil((component.widthMm + component.heightMm) / requestedSpacingMm / MAX_GRID_LINES),
  );
  const spacingMm = requestedSpacingMm * factor;
  const lines = (size: number): number[] =>
    Array.from(
      { length: Math.max(0, Math.ceil(size / spacingMm) - 1) },
      (_, index) => (index + 1) * spacingMm,
    );
  return { spacingMm, vertical: lines(component.widthMm), horizontal: lines(component.heightMm) };
};
